// Plain-language labels for the commercial layer, shared by the banner and the
// billing page so a feature is never called two different things.

export const FEATURE_LABEL = {
  gmail: 'Gmail and Drive intake',
  normalization: 'Financial standardization',
  dd_tracking: 'Diligence request lists and workstreams',
  diligence_analysis: 'File-by-file diligence analysis',
  docs: 'IOI, LOI, IC memo and term sheet',
  lbo: 'LBO model and sensitivities',
  operating_model: 'Operating model and build-up',
  templates: 'Template library',
  template_branding: 'Your branding in documents',
  monitoring: 'Portfolio monitoring',
  alerts: 'Decline alerts and digests',
  board_deck: 'Board deck',
  sso: 'SSO and audit log',
  multi_fund: 'Multiple funds',
  priority_support: 'Priority support',
};

export const PLAN_LABEL = {
  trial: 'Trial',
  screening: 'Screening',
  deal_team: 'Deal Team',
  firm: 'Firm',
  enterprise: 'Enterprise',
  internal: 'Full access',
};

export const PLAN_BLURB = {
  screening: 'Triage far more deals than you can read. Screening memos, thesis fit and intake.',
  deal_team: 'The full deal lifecycle, from scan to signed IOI. Adds Deal Review and the models.',
  firm: 'The portfolio on the same screen as the pipeline. Adds monitoring, alerts and decks.',
  enterprise: 'Dedicated tenant, private networking and a security review. Priced with you.',
};

export function money(value) {
  if (value === null || value === undefined) return 'Custom';
  return `$${Number(value).toLocaleString('en-US')}`;
}

export function planPrice(plan, cycle = 'annual') {
  if (plan.price_per_user_month === null || plan.price_per_user_month === undefined) return 'Custom';
  if (plan.price_per_user_month === 0) return 'Free';
  const rate = cycle === 'monthly'
    ? (plan.price_per_user_month_monthly ?? Math.round(plan.price_per_user_month * 1.2))
    : plan.price_per_user_month;
  return `${money(rate)} / user / mo`;
}

// What one invoice covers: twelve months when billed yearly, one when billed monthly.
export function termLabel(cycle) {
  return cycle === 'monthly' ? 'Monthly total' : 'Annual total';
}

export function cycleLabel(cycle) {
  return cycle === 'monthly' ? 'billed monthly' : 'billed yearly';
}

export function statusLabel(billing) {
  if (!billing) return '';
  if (billing.status === 'trialing') return `Trial · ${billing.trial_days_left} days left`;
  if (billing.status === 'pending_invoice') return 'Invoice requested';
  if (billing.status === 'canceled') return 'Canceled';
  if (billing.status === 'expired') return 'Trial ended';
  return 'Active';
}

export function shortDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
